import { render, staticRenderFns } from "./LocationCreateModal.vue?vue&type=template&id=2254992b&"
import script from "./LocationCreateModal.vue?vue&type=script&lang=js&"
export * from "./LocationCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports